export const statusesColors = {
  online: '#427169',
  optimal: '#57B0F4',
  subOptimal: '#62778E',
  error: '#EA5449',
}
